import {Component, OnInit} from '@angular/core';
import { DatePipe } from '@angular/common';
import {FormsModule} from '@angular/forms';
import {HubLogEntry} from '../../model/hub-session';
import {HubApiService} from '../../services/hub-api.service';

@Component({
  selector: 'hub-monitoring',
  imports: [DatePipe, FormsModule],
  templateUrl: './monitoring.component.html',
  styleUrl: './monitoring.component.css'
})
export class MonitoringComponent implements OnInit {
  logs: HubLogEntry[] = [];
  logTypes = ['', 'info', 'warn', 'error'];
  page = 1;
  pageSize = 50;
  total = 0;
  totalPages = 1;
  type = '';
  query = '';
  pendingQuery = '';
  loading = true;
  error = '';

  constructor(private hubApi: HubApiService) {
  }

  ngOnInit(): void {
    this.loadLogs();
  }

  applyFilters(): void {
    this.query = this.pendingQuery.trim();
    this.page = 1;
    this.loadLogs();
  }

  clearFilters(): void {
    this.type = '';
    this.query = '';
    this.pendingQuery = '';
    this.page = 1;
    this.loadLogs();
  }

  setPage(page: number): void {
    const nextPage = Math.min(Math.max(page, 1), this.totalPages);
    if (nextPage === this.page) return;
    this.page = nextPage;
    this.loadLogs();
  }

  logDate(timestamp: number): Date {
    return new Date(timestamp * 1000);
  }

  logIsoDate(timestamp: number): string {
    return this.logDate(timestamp).toISOString();
  }

  firstLogIndex(): number {
    if (this.total === 0) return 0;
    return (this.page - 1) * this.pageSize + 1;
  }

  lastLogIndex(): number {
    return Math.min(this.page * this.pageSize, this.total);
  }

  t(key: string): string {
    return this.hubApi.translate(key) || key;
  }

  private loadLogs(): void {
    this.loading = true;
    this.error = '';
    this.hubApi.listLogs(this.page, this.pageSize, this.type, this.query).subscribe({
      next: (response) => {
        this.logs = response.logs;
        this.page = response.page;
        this.pageSize = response.pageSize;
        this.total = response.total;
        this.totalPages = response.totalPages;
        this.loading = false;
      },
      error: (error) => {
        this.error = error.error?.message || this.t('HubLogsLoadFailedMessage');
        this.loading = false;
      }
    });
  }
}
